export default "__VITE_ASSET__BHkib72W__"